export class NavigationModel {

    currentPageTitle: string = 'start';
    currentTabTitle: string = 'workroles';
    isDisclaimerAccepted: boolean = false;
    isSidebarOpen: boolean = false;
    isNavigationEnabled: boolean = true;
    currentStep: number = -1;
    previousStep: number = -1;
    currentPage: string = "";
    routeIndexes: any = null;
    isApplicationInitiasized: boolean = false;

    isDesktop: boolean = true;
    browser: string = null;
    os: string = null;
    userAgentInfo: any = null;
    responsiveSize: string = null;

    loginResponseStatus: any = null;

    constructor(obj: any) {
        if (obj.hasOwnProperty('currentPageTitle')) {
            this.currentPageTitle = obj.currentPageTitle;
        }
        if (obj.hasOwnProperty('currentTabTitle')) {
            this.currentTabTitle = obj.currentTabTitle;
        }
        if (obj.hasOwnProperty('isDisclaimerAccepted')) {
            this.isDisclaimerAccepted = obj.isDisclaimerAccepted;
        }
        if (obj.hasOwnProperty('isNavigationEnabled')) {
            this.isNavigationEnabled = obj.isNavigationEnabled;
        }
    }
}
